import { Component, Input, OnInit } from '@angular/core';
import { MobileService } from '@service/mobile.service';

@Component({
  selector: 'go-to-link',
  templateUrl: './go-to-link.component.html',
  styleUrls: ['./go-to-link.component.scss'],
})
export class GoToLinkComponent implements OnInit {
  constructor(public mobileService: MobileService) {}

  @Input()
  public goToLinkText: string = '';

  ngOnInit(): void {}
}
